import React from "react";
import {
    SETTING_QUICK_ACCESS_BUTTON_CSS_CLASS,
    SETTING_QUICK_ACCESS_BUTTON_TARGET,
    SETTING_QUICK_ACCESS_BUTTON_TEXT
} from "../../../pages/config/settings";
import Link from "next/link";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {generateDownloadUrl} from "../../../utility/navigationUtil";
import {buttonStyle} from "../../../common/constants/buttonStyle";
import {PageGridPlacementType} from "../../types";
import {useThemeContext} from "../../../theming/ThemeContext";
import {useTheme} from "@mui/material/styles";
import {useLinkTracking} from "tracking/hooks/useLinkTracking";

export interface Props {
    page: any,
    fullWidth: boolean,
    buttonStyle?: React.CSSProperties
}

export const BUTTON_DEFAULT_COLOR = 'bgGreen';

export const buttonClasses: any = {
    bgGreen: buttonStyle.green,
    bgBlue: buttonStyle.blue,
    bgYellow: buttonStyle.yellow,
}

const QuickAccessButton = (props: Props) => {
    const {themeMode} = useThemeContext();
    const theme = useTheme();
    const headerItems = props.page?.grid?.placements.find(
        (p: PageGridPlacementType) => p.name === 'header')?.items;
    const button = headerItems && headerItems.length > 1 ? headerItems[1] : undefined;
    const buttonSettings = props.page?.quickAccessButton;
    const buttonCustomStyle = buttonClasses[buttonSettings?.[SETTING_QUICK_ACCESS_BUTTON_CSS_CLASS]] ||
                              buttonClasses[BUTTON_DEFAULT_COLOR];

    const serverDownload = props.page?.quickAccessDownload as {
        id: string;
        title?: string
    } | undefined;

    const localButtonStyle: any = {
        ...props.buttonStyle,
        ...buttonCustomStyle,
        ':hover': {
            ...buttonCustomStyle[':hover'],
            ...(themeMode === 'testament' ? {backgroundColor: theme.palette.primary.light} : {}),
            transition: 'background-color 0.25s linear',
        }
    };

    const href = serverDownload && serverDownload.id
        ? generateDownloadUrl(serverDownload.id, serverDownload.title)
        : buttonSettings?.[SETTING_QUICK_ACCESS_BUTTON_TARGET];

    const target = serverDownload && serverDownload.id ? "_blank" : undefined;

    const trackingHref = (serverDownload && serverDownload.id) ? href : null;
    const linkHandler = useLinkTracking({href: trackingHref, target: target as '_self' | '_blank'});

    return (button && buttonSettings?.[SETTING_QUICK_ACCESS_BUTTON_TARGET]
            ? <Button component={Link}
                      data-cypress={'quickAccessLink'}
                      id={"quick-access"}
                      href={href}
                      target={target}
                      onClick={linkHandler}
                      prefetch={false}
                      variant="contained"
                      fullWidth={props.fullWidth}
                      sx={localButtonStyle}>
                <Typography variant='ctaButton' sx={{lineHeight: "16px", marginY: "5px"}}>
                    {buttonSettings[SETTING_QUICK_ACCESS_BUTTON_TEXT]}
                </Typography>
            </Button>
            : null
    );
}
export default React.memo(QuickAccessButton);
